// extracted by mini-css-extract-plugin
export var container = "_5u-1";
export var editor = "_5u-2";
export var resizable = "_5u-3";
export var wrapper = "_5u-0";